// src/pages/Clients/components/EmailScheduleModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Form, Select, App } from "antd";
import { useDispatch } from "react-redux";
import { upsertEmailSchedule, fetchEmailSchedules } from "../clientsSlice";
import {
  getAllEmployeeUserApi,
  getClientUserApi,
} from "../../../apiservice/hrpayroll";

const { Option } = Select;

const EmailScheduleModal = ({ open, onClose, edit, authInfo }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  const [employees, setEmployees] = useState([]);
  const [clientUsers, setClientUsers] = useState([]);

  const calendarDays = Array.from({ length: 31 }, (_, i) => i + 1);

  useEffect(() => {
    if (open) loadData();
    if (edit) {
      form.setFieldsValue({
        employee_id: edit.employee_id,
        client_user_id: edit.client_user_id,
        report_day: edit.report_day,
      });
    } else form.resetFields();
  }, [edit, open]);

  const loadData = async () => {
    const [emp, clients] = await Promise.all([
      getAllEmployeeUserApi({ institution_id: 1 }),
      getClientUserApi(),
    ]);
    setEmployees(emp.data?.data || []);
    setClientUsers(clients.data || []);
  };

  const onFinish = async (values) => {
    const payload = {
      id: edit?.id || 0,
      employee_id: values.employee_id,
      client_user_id: values.client_user_id,
      report_day: values.report_day,
      action: edit ? "update" : "create",
    };

    await dispatch(upsertEmailSchedule(payload))
      .unwrap()
      .then((res) => {
        message.success(res?.msg || "Email schedule saved");
        dispatch(fetchEmailSchedules());
        onClose();
      })
      .catch((err) => message.error(err?.msg || "Failed"));
  };

  return (
    <Modal
      open={open}
      title={edit ? "Edit Email Schedule" : "New Email Schedule"}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText={edit ? "Save" : "Create"}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        requiredMark={(label, { required }) =>
          required ? (
            <>
              {label} <span style={{ color: "#ff4d4f" }}>*</span>
            </>
          ) : (
            label
          )
        }
      >
        <Form.Item
          label="Employee"
          name="employee_id"
          rules={[{ required: true, message: "Employee is required" }]}
        >
          <Select placeholder="Select Employee" showSearch>
            {employees.map((e) => (
              <Option key={e.id} value={e.id}>
                {e.user_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Client User"
          name="client_user_id"
          rules={[{ required: true, message: "Client User is required" }]}
        >
          <Select placeholder="Select Client User" showSearch>
            {clientUsers.map((u) => (
              <Option key={u.id} value={u.id}>
                {u.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Report Day"
          name="report_day"
          rules={[{ required: true, message: "Report day is required" }]}
        >
          <Select placeholder="Select Day">
            {calendarDays.map((d) => (
              <Option key={d} value={d}>
                {d}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailScheduleModal;
